const RYSN_SHOP_ENTRY_KEY = 'rysnShopButtonEntry';

function markHomepageShopButton(root = document) {
  if (!document.body || !document.body.classList.contains('template-index')) return;

  const candidates = root.querySelectorAll('a.button, a.button-secondary, button.button, [role="link"].button');
  for (const candidate of candidates) {
    const label = candidate.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    if (label === 'shop') {
      candidate.classList.add('rysn-shop-pulse-button');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => markHomepageShopButton());
} else {
  markHomepageShopButton();
}

document.addEventListener('shopify:section:load', (event) => markHomepageShopButton(event.target));

document.addEventListener('click', (event) => {
  const shopButton = event.target.closest('.rysn-shop-pulse-button');
  if (!shopButton || !shopButton.href) return;

  try {
    sessionStorage.setItem(RYSN_SHOP_ENTRY_KEY, 'true');
  } catch (_error) {
    // Navigation still works if storage is unavailable.
  }
});
